import { Button, Flex, ModalContext, Text } from "dash-ui";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

export const ApiTokenSection = ({ hasToken }: { hasToken: boolean | null }) => {
  const theme = useTheme();
  const { t } = useTranslation(["pages"]);

  const { toggleModal } = useContext(ModalContext);

  const handleGenerateTokenClick = () => {
    toggleModal(true, "GenerateNewApiToken");
  };

  return (
    <Flex mt={6} flexDirection="column">
      <Flex mb={4}>
        {hasToken ? (
          <Text color={theme.colors.n70}>
            There is already an active token associated with this App ID.
            <br />
            You can generate a new one by clicking on the button below, but the
            current token <strong>will be invalidated</strong>.
          </Text>
        ) : (
          <Text color={theme.colors.n70}>
            There is no active token associated with this App ID.
            <br />
            You can generate a new one by clicking on the button below.
          </Text>
        )}
      </Flex>
      <Button mb={4} icon="plus" px={5.5} onClick={handleGenerateTokenClick}>
        {t("pages:profilePage:api:generateNewToken")}
      </Button>
    </Flex>
  );
};
